import { render, staticRenderFns } from "./NewUserList.vue?vue&type=template&id=fed7cd12&scoped=true"
import script from "./NewUserList.vue?vue&type=script&lang=js"
export * from "./NewUserList.vue?vue&type=script&lang=js"
import style0 from "./NewUserList.vue?vue&type=style&index=0&id=fed7cd12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed7cd12",
  null
  
)

export default component.exports